import React from 'react';
import AutoSaveDropdown from "./AutoSaveDropdown";

const AutoSaveBlackOrWhiteDropdown = (props) => <AutoSaveDropdown {...props} options={[
  {value: '#333333', textKey: 'color.black'},
  {value: '#FFFFFF', textKey: 'color.white'}
]}/>;

export default AutoSaveBlackOrWhiteDropdown;


// WEBPACK FOOTER //
// ./public/components/forms/AutoSaveFormFields/AutoSaveBlackOrWhiteColorDropdown.jsx